/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const CategorieType = new ObjectType({
    name: 'CategorieItem',
    description: 'Cet objet represente une catégorie',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la catégorie',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la catégorie',
            resolve: (root) => root.slug
        },
        name: {
            type: StringType,
            description: 'Le nom de la catégorie',
            resolve: (root) => root.name
        },
    }),
});

export default CategorieType;



// WEBPACK FOOTER //
// ./data/types/CategorieType.js